






import { Component, Vue } from "vue-property-decorator";
import SupervisiUmumList from "@/components/ppi/supervisi-umum/SupervisiUmumList.vue";

@Component({
  components: { SupervisiUmumList }
})
export default class SupervisiUmumPage extends Vue {}
